// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/video.js/6.5.0/video-js.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".videoViewerWrapper[data-v-3e556ac4]{position:relative;overflow:hidden;width:100%;height:100%;background-color:#a9a9a9}.video-js[data-v-3e556ac4]{position:static;background-color:#a9a9a9}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
